import {ViolationLineItemTargetModel} from './ViolationLineItemTarget.model';
import {ViolationOtherTargetModel} from './ViolationOtherTarget.model';
import {Target} from '@wix/auto_sdk_ecom_current-cart';

export class ViolationTargetModel {
  public lineItemTarget?: ViolationLineItemTargetModel;
  public otherTarget?: ViolationOtherTargetModel;

  constructor(params: ViolationTargetModel) {
    this.lineItemTarget = params.lineItemTarget;
    this.otherTarget = params.otherTarget;
  }

  public static fromCartV1(target: Target) {
    return new ViolationTargetModel({
      lineItemTarget: target?.lineItem && ViolationLineItemTargetModel.fromCartV1(target.lineItem),
      otherTarget: target?.other && ViolationOtherTargetModel.fromCartV1(target.other),
    });
  }

  public static fromCartV2(target: Target): ViolationTargetModel {
    return new ViolationTargetModel({
      lineItemTarget: target?.lineItem && ViolationLineItemTargetModel.fromCartV2(target.lineItem),
      otherTarget: target?.other && ViolationOtherTargetModel.fromCartV2(target.other),
    });
  }
}
